import React from 'react';
import Download from 'components/download';
import constants from '../constants';

const EmissionsDescriptionPage = () => (
  <div className="container">
    <div className="l-demo-content">
      <div className="tab-content-description">
        <div className="row justify-content-md-center">
          <div className="col-md-10">
            <div className="summary">
              <p>A monthly detailed estimate of air emissions mainly obtained from satellites among other pollution sources. Using satellites allow us to offer global scale emissions inventory at 1Km. resolution for any region of the world. Emissions are classified by four sourcing sectors: industry, transport, power and residential.</p>
            </div>
          </div>
          <div className="col-md-12">
            <div className="characteristics-table">
              <div className="col-md-12">
                <div className="main-characteristics">
                  Main characteristics
                </div>
              </div>
              <div className="row justify-content-md-center">
                <div className="col-md-10">

                  <div className="table-item">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="table-label">
                          Air pollutants
                        </div>
                      </div>

                      <div className="col-md-8">
                        <div className="table-value">
                          NOx, SO2 and aerosols of various types.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="table-item">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="table-label">
                          Spatial Resolution
                        </div>
                      </div>

                      <div className="col-md-8">
                        <div className="table-value">
                          <div className="value-list">
                            <ul>
                              <li>25 km for all regions.</li>
                              <li>1 Km on-demand request.</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="table-item">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="table-label">
                          Temporal Range
                        </div>
                      </div>

                      <div className="col-md-8">
                        <div className="table-value">
                          From 2014 until today Temporal Resolution: Monthly (daily for fire products).
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="table-item">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="table-label">
                          Update frequency
                        </div>
                      </div>

                      <div className="col-md-8">
                        <div className="table-value">
                          Monthly (daily for fire products).
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-10">
            <div className="main-1">
              Up-to-date and reliable emission inventories are essential for accurate air quality modelling and forecasting on various spatial scales. These inventories are also used by policy makers to evaluate the effectiveness of emission abatement measures, and to decide on future strategies. Unfortunately, traditional bottom-up emission inventories are often inaccurate and are always a few years behind the actual developments. Inventory updates (if available at all) are usually based on partly updates of the underlying proxy data , leading to different time frames for different sectors and sources. Satellite observations of air constituents provide a new way of estimating emissions. The main advantage of these top-down emission estimates are the spatial and temporal consistency for all sectors and pollutants, a high temporal resolution, and the rapid availability.
            </div>

            <div className="main-2">
              Our time to market is just 3 months to implement it, being then able to offer periodical monthly emission inventories.
            </div>
          </div>
        </div>
        <Download pdf={constants.emissions.factsheet} />
      </div>
    </div>
  </div>

);

export default EmissionsDescriptionPage;



// WEBPACK FOOTER //
// ./src/pages/products/emissions/description.js